
import React,{useContext, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {UserContex} from '../App'

import Header from '../components/Header';
import Footer from '../components/Footer';
const Login = ()=>{
  const {state, dispatch }= useContext(UserContex)
  const navigate= useNavigate()
  const [email,setEmail] =  useState("");
  const [password,setPassword] =  useState("");
  const [user,setUser] = useState(true)
  const [vendor,setVendor] = useState(false)
  const [participant,setParticipant] = useState(false)


  const PostData =()=>{

   if(vendor){
    fetch("/signinVendor",{
      method:"post",
      headers:{
          "Content-Type":"application/json"
      },
      body: JSON.stringify({
        
          password,
          email:email
      })
      
  }).then(res=>res.json())
  .then(data=> {
     
      if(data.error){
        toast.error(data.error)

      }
      else{
          localStorage.setItem("jwt", data.token)
          localStorage.setItem("vendor", JSON.stringify( data.token))
          dispatch({type:"VENDOR", payload:data.token})
          navigate('/dashboard')
        }
  })
  .catch(err=>{
      console.log(err)
  })
   } 
   
   else if(user){

    fetch("/signinUser",{
      method:"post",
      headers:{
          "Content-Type":"application/json"
      },
      body: JSON.stringify({
        
          password,
          email:email
      })
      
  }).then(res=>res.json())
  .then(data=> {
     
      if(data.error){
        toast.error(data.error)

      }
      else{
          localStorage.setItem("jwt", data.token)
          localStorage.setItem("user", JSON.stringify( data.token))
          dispatch({type:"USER", payload:data.token})
          navigate('/profile')
        }
  })
  .catch(err=>{
      console.log(err)
  })

   }
   else if(participant){

    fetch("/signinParticipant",{
      method:"post",
      headers:{
          "Content-Type":"application/json"
      },
      body: JSON.stringify({
        
          password,
          email:email
      })
      
  }).then(res=>res.json())
  .then(data=> {
     
      if(data.error){
        toast.error(data.error)

      }
      else{
          localStorage.setItem("jwt", data.token)
          localStorage.setItem("participant", JSON.stringify( data.user))
          dispatch({type:"USER", payload:data.user})
          navigate(`/participantprofile/${data.user._id}`)
        }
  })
  .catch(err=>{
      console.log(err)
  })

   }


       }

    return(


<>
<Header></Header>
  {/* component */}
  <style dangerouslySetInnerHTML={{__html: "@import url('https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.3.45/css/materialdesignicons.min.css')" }} />
  <div className="bg-white min-w-screen min-h-screen -mt-10  flex flex-col items-center justify-center px-5 py-5 overflow-y-auto  overflow-x-hidden  ">


<div class="flex justify-center items-center mb-4  mx-2 md:w-9/12 w-full">
  
  <button onClick={()=>{setUser(false); setVendor(true);setParticipant(false)}} type="button" class={` w-1/2  py-2 text-base font-medium text-black ${vendor?"bg-purple-500 text-white":"bg-white"}  border rounded-r-md hover:text-white hover:bg-purple-500`}>
      Vendor
  </button>
  <button 
  onClick={()=>{setUser(true); setVendor(false);setParticipant(false)}}
  type="button" class={` w-1/2  py-2 text-base font-medium text-black ${user?"bg-purple-500 text-white":"bg-white"}  border rounded-r-md hover:text-white hover:bg-purple-500`}>
      User
  </button>
  {/* <button 
  onClick={()=>{setParticipant(true); setVendor(false); setUser(false)}}
  type="button" class={`md:w-1/3 w-1/3  py-2 text-base font-medium text-black ${participant?"bg-purple-500 text-white":"bg-white"}  border rounded-r-md hover:text-white hover:bg-purple-500`}>
    Participant
  </button> */}
</div>
    <div className=" text-gray-500 rounded-3xl shadow-xl w-full overflow-hidden" style={{maxWidth: 1000}}>
     



      <div className="md:flex w-full bg-gray-100">
        <div className="hidden md:block w-1/2 bg-gray-50 py-10 px-10">

            <img  src='./logo.png'></img>
        </div>
        <div className="w-full md:w-1/2 py-10 px-5 md:px-10">
          <div className="text-center mb-10">
            <h1 className="font-bold text-3xl text-gray-900">{vendor?"Login Vendor":user?"Login User":"Login Participant"}</h1>
          </div>
          <div>
          <div className="flex -mx-3">
              
            </div>
            <div className="flex -mx-3">
              <div className="w-full px-3 mb-5">
                <label htmlFor className="text-md text-gray-600 font-semibold px-1">Email</label>
                <div className="flex">
                  <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i className="mdi mdi-email-outline text-gray-400 text-lg" /></div>
                  <input type="email" required 
                  className="w-full -ml-10 pl-10 pr-3 py-2 placeholder-gray-400  rounded-lg border-2 border-gray-200 outline-none focus:border-indigo-500" 
                  placeholder="youremail@example.com"
                  value={email}
                  onChange={(e)=>setEmail(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="flex -mx-3">
              <div className="w-full px-3 mb-5">
                <label htmlFor className="text-md  text-gray-600 font-semibold px-1">Password</label>
                <div className="flex">
                  <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i className="mdi mdi-account-outline text-gray-400 text-lg" /></div>
                  <input type="password"  required
                  className="w-full -ml-10 pl-10 pr-3 py-2 placeholder-gray-400  rounded-lg border-2 border-gray-200 outline-none focus:border-indigo-500" 
                  placeholder="Password"
                  value={password}
                  onChange={(e)=>setPassword(e.target.value)}
                  />
                </div>
              </div>
            </div>
           
            

            <div className="w-full px-3 mb-5">
                <button className="block w-full max-w-xs mx-auto bg-purple-500 hover:bg-purple-400 focus:bg-blue-400 text-white rounded-lg px-3 py-3 font-semibold"
                
                onClick={()=> PostData()}

            

                >Login</button>
               <ToastContainer/>

              </div>

                  {vendor?
                    <div className=" px-12 mb-6 object-center"> 
                                <a href="/reset">
                                    Forgot Password?
                                </a>
                                <br></br>
                                <a href="/vendorSignup">
                                    Create Organizers Account?
                                </a>
                              </div>

                  : user?
                  <div className=" px-12 mb-6 object-center"> 
                                <a href="/resetuserpassword">
                                    Forgot Password?
                                </a>
                                <br></br>
                                <a href="/register">
                                    Register Account?
                                </a>
                              </div>:

                    <div className=" px-12 mb-6 object-center"> 
                    <a href="/resetparticipantpassword">
                        Forgot Password?
                    </a>
                    <br></br>
                    </div>
                  }
            
              
    </div>
</div>

        
          </div>
        </div>
      </div>
      <Footer page="profile"></Footer>

</>
  


    );
}

export default Login;